module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Modal', {
    attrs: {
      "wide": false,
      "width": "500px"
    },
    on: {
      "close": _vm.localCloseModal
    }
  }, [(!_vm.scanningOpen) ? _c('h1', [_vm._v(_vm._s(_vm.$t('skipass.refill-header')))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "blocked tab-picker center"
  }, [_c('label', {
    staticClass: "uppercase"
  }, [_vm._v("Välj sparat eller lägg in ett nytt")]), _vm._v(" "), _c('div', {
    class: 'box checkboxes'
  }, [_c('Checkbox', {
    attrs: {
      "special-class": "skipass-user",
      "label": "Nytt",
      "label-position": "right",
      "value": false,
      "valuebinder": _vm.tabSaved
    },
    on: {
      "update:valuebinder": function($event) {
        _vm.tabSaved = $event
      }
    }
  }), _vm._v(" "), _c('Checkbox', {
    attrs: {
      "special-class": "skipass-user",
      "label": "Sparat",
      "label-position": "right",
      "value": true,
      "valuebinder": _vm.tabSaved
    },
    on: {
      "update:valuebinder": function($event) {
        _vm.tabSaved = $event
      }
    }
  })], 1)]), _vm._v(" "), (_vm.tabSaved) ? _c('div', {
    staticClass: "tab-saved"
  }, [(!_vm.loggedIn) ? _c('div', [_c('Login', {
    on: {
      "login": _vm.onLogin
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.loggedIn && !_vm.skipasses.length && !_vm.loading) ? _c('div', [_c('div', {
    staticClass: "blocked info"
  }, [_c('b', [_c('icon', {
    attrs: {
      "name": "info",
      "scale": 1.4
    }
  }), _vm._v("Inga liftkort")], 1), _vm._v(" "), (_vm.foundNotAllowedDelivery) ? _c('p', [_vm._v("Vi hittade inga sparade liftkort.")]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.loggedIn && _vm.loading) ? _c('div', [_c('div', {
    staticClass: "blocked center"
  }, [_c('Loading', {
    attrs: {
      "show": _vm.loading,
      "static": true
    }
  })], 1)]) : _vm._e(), _vm._v(" "), (_vm.loggedIn && _vm.skipasses.length) ? _c('div', [_c('div', {
    staticClass: "blocked center"
  }, [_c('b', [_vm._v("Välj bland dina kort")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('Dropdown', {
    attrs: {
      "options": _vm.skipassesAsSelect,
      "valuebinder": _vm.cardId,
      "validated": _vm.cardId,
      "label": "Välj liftkort"
    },
    on: {
      "update:valuebinder": function($event) {
        _vm.cardId = $event
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "blocked center"
  }, [_c('button', {
    attrs: {
      "disabled": !_vm.cardId
    },
    on: {
      "click": function($event) {
        return _vm.useNumber()
      }
    }
  }, [_vm._v("Använd")])])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (!_vm.tabSaved) ? _c('div', {
    staticClass: "tab-new"
  }, [(!_vm.scanningOpen) ? _c('div', {
    staticClass: "blocked center"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('skipass.enter-number')))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "number-wrapper"
  }, [_c('Dropdown', {
    attrs: {
      "options": _vm.options,
      "valuebinder": _vm.prefix,
      "validated": _vm.prefix,
      "value-as-label": true,
      "label": "00"
    },
    on: {
      "update:valuebinder": function($event) {
        _vm.prefix = $event
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "mask",
      rawName: "v-mask",
      value: (_vm.pattern),
      expression: "pattern"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.number),
      expression: "number"
    }],
    class: {
      validated: _vm.validate(), error: _vm.error()
    },
    attrs: {
      "type": "tel",
      "placeholder": _vm.placeholder
    },
    domProps: {
      "value": (_vm.number)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.number = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "button small",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.scanningOpen = true
      }
    }
  }, [_c('icon', {
    attrs: {
      "name": "camera-white",
      "scale": 2
    }
  })], 1)], 1)]) : _vm._e(), _vm._v(" "), (_vm.scanningOpen) ? _c('div', {
    staticClass: "blocked center"
  }, [_c('button', {
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.$refs.scanner.shutdown();
        _vm.scanningOpen = false
      }
    }
  }, [_vm._v("Avbryt skanning")]), _vm._v(" "), _c('Scanner', {
    ref: "scanner",
    attrs: {
      "on-success": _vm.onScannerSuccess
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.wasScanned && _vm.error()) ? _c('div', {
    staticClass: "blocked center info error-box",
    staticStyle: {
      "text-align": "left"
    }
  }, [_c('b', [_c('icon', {
    attrs: {
      "name": "info",
      "scale": 1.4
    }
  }), _vm._v("Ogiltigt kortnummer")], 1), _vm._v(" "), _c('p', [_vm._v("Vänligen korrigera manuellt eller försök skanna igen. Observera att gamla liftkort inte alltid kan skannas.")])]) : _vm._e(), _vm._v(" "), (!_vm.scanningOpen) ? _c('div', {
    staticClass: "blocked center"
  }, [_c('button', {
    attrs: {
      "disabled": !_vm.validate()
    },
    on: {
      "click": function($event) {
        return _vm.setNumber()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('skipass.add-number')))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "blocked info"
  }, [_c('b', [_c('icon', {
    attrs: {
      "name": "info",
      "scale": 1.4
    }
  }), _vm._v(_vm._s(_vm.$t('skipass.old-keycard-title')))], 1), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('skipass.old-keycard-text')))])]), _vm._v(" "), _c('div', {
    staticClass: "blocked center keycard-img"
  }, [_c('img', {
    attrs: {
      "src": "https://static.booking.branasgruppen.se/static/img/liftkort-nr.jpg"
    }
  })])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4e8010ce"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modals/SkiPassRefill.vue
// module id = 972
// module chunks = 0